import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

// AUTH LOGIN
export const loginUser = createAsyncThunk(
  "auth/login",
  async (authData, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.post(
        `/v1/admin/auth/loginAuth`,
        authData
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// AUTH LOGOUT
export const logoutUser = createAsyncThunk(
  "auth/logout",
  async (_, thunkAPI) => {
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token;
      if (!token) throw new Error("No token found");

      const response = await axiosInstanceJson.post(`/v1/admin/auth/logout`, {
        token,
      });

      localStorage.removeItem("user");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
